export default class DeskpadHotkeys {
  constructor(canvas) {
    this.canvas = canvas;
  }

  handleKeypress = e => {
    const { canvas } = this;

    if (e.ctrlKey) {
      switch (e.code) {
        case "Equal":
          canvas.zoomIn();
          e.preventDefault();
          e.stopPropagation();
          break;

        case "Minus":
          canvas.zoomOut();
          e.preventDefault();
          e.stopPropagation();
          break;

        case "KeyZ":
          canvas.DPE.history.undo();
          break;

        case "KeyY":
          canvas.DPE.history.redo();
          break;

        default:
          break;
      }

      return;
    }

      var movementDelta = 0.5;
      if (e.shiftKey) {
        movementDelta = 0.1;
      }

      var activeObject = canvas.getActiveObject();

      if (e.keyCode === 37) {
        e.preventDefault(); // Prevent the default action
        if (activeObject) {
          const a = activeObject.get('left') - movementDelta;
          activeObject.set('left', a);
        }
      } else if (e.keyCode === 39) {
        e.preventDefault(); // Prevent the default action
        if (activeObject) {
          const a = activeObject.get('left') + movementDelta;
          activeObject.set('left', a);
        }

      } else if (e.keyCode === 38) {
        e.preventDefault(); // Prevent the default action
        if (activeObject) {
          const a = activeObject.get('top') - movementDelta;
          activeObject.set('top', a);
        }

      } else if (e.keyCode === 40) {
        e.preventDefault(); // Prevent the default action
        if (activeObject) {
          const a = activeObject.get('top') + movementDelta;
          activeObject.set('top', a);
        }
      }

      if (activeObject) {
        canvas.fire('object:moving', { target: activeObject });
        canvas.fire('object:moved', { target: activeObject });
        canvas.renderAll();
      }

    switch (e.key) {
      // case "Backspace":
      case "Delete":
        canvas.remove(canvas.getActiveObject());
        break;

      default:
        break;
    }
  };

  enable = _ => {
    const { handleKeypress } = this;
    const wrapElement = document;
    wrapElement.tabIndex = 1000;
    wrapElement.addEventListener("keydown", handleKeypress, false);
  };

  disable = _ => {
    const { handleKeypress } = this;
    const wrapElement = document;
    wrapElement.removeEventListener("keydown", handleKeypress);
  };
}
